import { style } from '@vanilla-extract/css';

export const genericEmbedContainer = style({
  padding:
    'var(--wt-hyperlink-margin-top) calc(var(--wt-hyperlink-margin-right) + var(--wt-padding-right-value-w-fallback)) var(--wt-hyperlink-margin-bottom) calc(var(--wt-hyperlink-margin-left) + var(--wt-padding-left-value-w-fallback))',

  selectors: {
    '&:hover': {
      filter: 'brightness(90%)',
    },
  },
});

export const genericEmbedChildrenContainer = style({
  flex: 1,
});

export const genericEmbed = style({
  backgroundColor: 'var(--wt-hyperlink-background-color)',
  borderColor: 'var(--wt-hyperlink-border-color)',
  borderWidth:
    'var(--wt-hyperlink-border-top-width) var(--wt-hyperlink-border-right-width) var(--wt-hyperlink-border-bottom-width) var(--wt-hyperlink-border-left-width)',
  borderRadius:
    'var(--wt-hyperlink-border-radius-top-left) var(--wt-hyperlink-border-radius-top-right) var(--wt-hyperlink-border-radius-bottom-left) var(--wt-hyperlink-border-radius-bottom-right)',
  padding:
    'var(--wt-hyperlink-padding-top) var(--wt-hyperlink-padding-right) var(--wt-hyperlink-padding-bottom) var(--wt-hyperlink-padding-left)',
});
